import { PopularImages } from "@components/popular-images";
import { Blockquote, Heading, SegmentedControl } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { FileInputOrLink } from "../components/file-input-or-link";
import { ModeBaseProps } from "./types";

interface ImageModeProps extends ModeBaseProps {
  similarity: number;
  setSimilarity: (value: number) => void;
}

export const ImageMode = ({
  fromImage,
  setFromImage,
  similarity,
  setSimilarity,
}: ImageModeProps) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="space-y-2">
        <FileInputOrLink
          heading={t("camera.form.image.from_image")}
          fromImage={fromImage}
          setFromImage={setFromImage}
        />
      </div>

      <div className="space-y-2">
        <Heading size="1">
          {t("camera.form.image.from_image_similarity")}
        </Heading>
        <div className="flex flex-row items-center space-x-2">
          <SegmentedControl.Root
            size="1"
            className="w-full"
            value={similarity + ""}
            onValueChange={(o) => setSimilarity(parseInt(o))}
          >
            <SegmentedControl.Item value="1">0%</SegmentedControl.Item>
            <SegmentedControl.Item value="20">20%</SegmentedControl.Item>
            {false && (
              <SegmentedControl.Item value="80">80%</SegmentedControl.Item>
            )}
            <SegmentedControl.Item value="100">100%</SegmentedControl.Item>
          </SegmentedControl.Root>
        </div>
        <Blockquote size="2">
          {t(
            "camera.form.image.from_image_similarity_description." +
              (similarity === 100
                ? "4"
                : similarity > 75
                ? "3"
                : similarity > 18
                ? "2"
                : "1")
          )}
        </Blockquote>
      </div>

      {false && (
        <PopularImages
          type="image_image"
          onChange={(item) => setFromImage(item.url)}
        />
      )}
    </>
  );
};
